import { Fragment, useEffect, useState } from "react"
import { Col, Row } from "reactstrap"
import Body from "./Body"
import Header from "./Header/Header"
import FilterHeader from "./FilterHeader"
import { getGeneralInformation } from "helpers/app-backend"
import { totalGeneral } from "../../../common/data/totalGeneral"
import { sampleResult } from "../../../common/data/sampleResult"

const GeneralDashboard = ({ }) => {

  const [data, setData] = useState({})
  const [loading, setLoading] = useState(false)
  const [filters, setFilters] = useState({
    periodOption: "1",
    category: ""
  })

  const fetchData = async (filterParams = filters) => {
    try {
      setLoading(true)

      // Prepare query parameters
      const queryParams = {
        periodOption: filterParams.periodOption,
        category: filterParams.category
      }

      const res = await getGeneralInformation(queryParams)
      setData(res)
    } catch (error) {
      console.error("Error fetching dashboard data:", error)
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchData()
  }, [])

  useEffect(() => {
  }, [data])

  const handleFilterChange = (newFilters) => {
    setFilters(newFilters)
    fetchData(newFilters)
  }

  return (
    <Fragment>
      <Row data-dashboard="general">
        <Col lg="12">
          <div style={{ padding: '10px 0' }}>
            <FilterHeader
              onFilterChange={handleFilterChange}
              currentFilters={filters}
              loading={loading}
            />
          </div>
          <Col lg="12">
            <Header data={data?.totalGeneral ?? totalGeneral} />
          </Col>
        </Col>
        <Col lg="12" style={{}}>
          <Body
            data={{
              stateSample: data?.stateSample ?? {},
              totalSampleDaily: data?.totalSampleDaily || {},
              dailySampleDensity: data?.dailySampleDensity || {},
              rateOfResultsByCategory: data?.rateOfResultsByCategory || sampleResult,
              statusInstruments: data?.statusInstruments || [],
            }}
          />
        </Col>
        {/* <Col lg="12" style={{}}>
          <Footer
            data={{
              totalSampleDaily: data?.totalSampleDaily || {},
              dailySampleDensity: data?.dailySampleDensity || {}
            }}
          />
        </Col> */}
      </Row>
    </Fragment>
  )
}
export default GeneralDashboard
